import React, { useState, useEffect, useRef } from 'react';
import 'antd/dist/antd.css';
import '@ant-design/compatible/assets/index.css';
import _ from 'lodash'; // Import the entire lodash library
import { Grid, AutoSizer } from 'react-virtualized';
import { Col, Tag } from 'antd';
import { getRelevanceBasedOrderedSearchResult } from '../../Utilities';
import SceneCard from './SceneCard';
import ENVIRONMENT from '../../../../environments';

const RoomsListVirtualized = (props) => {
  const virtualizerContainer = useRef();
  const [filteredValues, setFilteredValues] = useState([]);
  const [columnCount, setColumnCount] = useState(4);
  const [rowCount, setRowCount] = useState(0);
  const maxColWidth = 280;
  const {
    selectedRoom,
    setSelectedRoom,
    roomsData,
    type,
    searchValue,
    selectedCategories,
    setSelectedCategories,
    requestPlan,
    setData,
    multiple_select,
    selectedScenes,
    setSelectedScenes,
    creationType,
    isStore,
    requestStatusRoom
  } = props;
  const filtersHeight = `calc(100vh - ${
    selectedCategories.length > 0 ? '300px' : '220px'
  })`;

  const handleSpaceClick = (value) => {
    console.log(value)
    if(multiple_select){
        if(selectedScenes.find(ele => ele.id === value.id)){
            setSelectedScenes(selectedScenes.filter((ele) => ele.id !== value.id));
        }
        else
            setSelectedScenes([...selectedScenes, value]);
    }else{
        if (selectedRoom === value) {
            setSelectedRoom(null);
          } else setSelectedRoom(value);
    }
  };

  const cellRenderer = ({ columnIndex, key, rowIndex, style }) => {
    const data = filteredValues;
    const itemIndex = rowIndex * columnCount + columnIndex;
    const ele = data[itemIndex] && data[itemIndex];
    if (!ele) {
      return null;
    }
    const id = ele.room_id ?? ele.id;
    let selectedId = []
    if(multiple_select){
        selectedId = selectedScenes.map((ele) => ele.id)
    }
    else{
        selectedId.push(type === 'space' ? selectedRoom?.room_id : selectedRoom?.id)
    }
      
    const name = type === 'space' ? ele.room_name : ele.name;
    let thumbnail = ele.thumbnail;

    if (thumbnail && thumbnail.includes(ENVIRONMENT.DEFAULT_BASE_URL)) {
      thumbnail = thumbnail.replace(
          ENVIRONMENT.DEFAULT_BASE_URL,
          ENVIRONMENT.getBaseURL(ele.platform),
      );
    } else if (thumbnail && !thumbnail.includes('https')) {
      thumbnail =
        ENVIRONMENT.getBaseURL(ele.platform) +
        ENVIRONMENT.SCENE_THUMBNAIL_URI +
        ele.id +
        '/' +
        ele.thumbnail;
    }

    return (
      <div key={key} style={style}>
        <SceneCard
          item_type={ele.item_type}
          id={ele.room_id ?? ele.id}
          name={type == 'scene' ? ele.name : ele.room_name}
          price={ele.price}
          customer_username={
            type == 'scene' ? ele.requested_by : ele.customer_username
          }
          company_display_name={ele.company_display_name}
          company_id={ele.company_id}
          getRequestPlan={requestPlan}
          itemType={type}
          thumbnail={thumbnail}
          category={type == 'scene' ? ele.room_name : ele.category}
          subscriptionPlan={''}
          platform={ele.platform}
          ele={ele}
          handleAddClick={handleSpaceClick}
          selectedId={selectedId}
          creationType={creationType}
          selectedScenes={selectedScenes}
          setSelectedScenes={setSelectedScenes}
          isStore={isStore}
          requestStatusRoom = {requestStatusRoom}
        />
      </div>
    );
  };

  const closeTags = (entity) => {
    const arr = selectedCategories.filter((category) => {
      return entity != category;
    });
    setSelectedCategories(arr);
  };

  useEffect(() => {
    if (searchValue || selectedCategories.length) {
      const data = searchValue ?
        getRelevanceBasedOrderedSearchResult(searchValue, roomsData) :
        getRelevanceBasedOrderedSearchResult(
            selectedCategories.join(' '),
            roomsData,
        );
      setFilteredValues(data);
      setData(data);
      setRowCount(Math.ceil(data.length / columnCount));
    } else {
      setFilteredValues(roomsData);
      setData(roomsData);
      setRowCount(Math.ceil(roomsData.length / columnCount));
    }
  }, [roomsData, searchValue, selectedCategories]);

  return (
    <>
      {selectedCategories.length > 0 && (
        <Col span={24} style={{ marginLeft: 10 }}>
          <h4 className="manrope f-14 black-55 italic">Showing results for</h4>
          <div style={{ marginBottom: 20 }}>
            {selectedCategories.length > 0 &&
              selectedCategories.map((category) => {
                return (
                  <Tag
                    key={category}
                    onClose={() => closeTags(category, 'space_category')}
                    closable
                    visible={true}
                    className="manrope f-12 black-55 tag-filter"
                  >
                    Category:{' '}
                    <span className="manrope f-12 grey-77">{category}</span>
                  </Tag>
                );
              })}
          </div>
        </Col>
      )}
      <div
        ref={virtualizerContainer}
        style={{ width: '100%', height: filtersHeight }}
      >
        {roomsData.length == 0 && (
          <div
            className="empty-section"
            style={{
              marginTop: '10%',
              position: 'relative',
              textAlign: '-webkit-center',
            }}
          >
            <img
              id="empty-section-image"
              style={{ width: '10%' }}
              src="../../../../img/Collections.svg"
            />
            <p className="empty-section-text manrope f-14 black-55">
              Nothing to show
            </p>
          </div>
        )}
        <AutoSizer>
          {({ height, width }) => {
            const colCount =
              (Math.floor(width / maxColWidth) > 4 ?
                4 :
                Math.floor(width / maxColWidth)) || 1;
            setColumnCount(colCount);
            setRowCount(Math.ceil(filteredValues.length / colCount));
            const colWidth = width / colCount;
            return (
              <Grid
                className='product-tab-content-scrollable'
                cellRenderer={cellRenderer}
                columnCount={colCount}
                columnWidth={colWidth}
                height={height}
                rowCount={rowCount}
                estimatedRowSize={100}
                rowHeight={390}
                width={width + 10}
              />
            );
          }}
        </AutoSizer>
      </div>
    </>
  );
};

export default RoomsListVirtualized;
